import firebase from "firebase/app";
import "firebase/auth";
import 'firebase/analytics';

class Firebase {
  constructor() {
    firebase.initializeApp({
      apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_Id,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_Id,
      appId: process.env.REACT_APP_FIREBASE_APP_ID,
      measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
    });

    this.auth = firebase.auth();
    this.firAnalytics = firebase.analytics();

    // To apply the default browser preference for language
    this.auth.useDeviceLanguage();
  }

  /**
   * Used to analys the user activity by firebase.
   * @param  {String} name
   * @param  {Object} parameters
   */
  FIRAnalytics = (name, parameters) => this.firAnalytics.logEvent(name, { ...parameters });

  recaptchaVerifier = fallback => {
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      "sign-in-button",
      {
        size: "invisible",
        callback: response => {
          fallback(response);
        },
      }
    );
    window.recaptchaVerifier.render().then((widgetId) => {
      window.recaptchaWidgetId = widgetId;
    });
  };

  /**
   * Used To verify user phonenumber by firebase and then fallback if verified sccessfully.
   * @param  {Number} phoneNumber
   * @param  {Function} fallback
   */
  signInWithPhoneNumber = (phoneNumber, fallback) => {
    var appVerifier = window.recaptchaVerifier;
    this.auth
      .signInWithPhoneNumber(phoneNumber, appVerifier)
      .then(confirmationResult => {
        fallback(confirmationResult, null);
        window.confirmationResult = confirmationResult;
      })
      .catch(err => {
        fallback(null, err);
        this.reset();
      });
  };

  signOut = () => {
    this.auth.signOut().then(() => {
      // Sign-out successful.
      window.location.href = '/logout';
    }).catch((error) => {
      console.log(error);
      // An error happened.
    });
  }

  reset = () => {
    if (window.recaptchaVerifier) {
      window.recaptchaVerifier.render().then(widgetId => {
        window.recaptchaVerifier.reset(widgetId);
      });
    }
  }
}

export default Firebase;
